module.exports = __webpack_public_path__ + "img/xieshou-banner-light.fae9ccbe.png";